import Vue from 'vue';
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function ShippingAddressModalController () {
    this.tag = '';
    this.busModal = new Vue();
    this.shippingProfile = {};

    //#region callback event
    this.cbAction = new CallbackEvent();
    this.cbClose = new CallbackEvent();
    //#endregion callback event

    //#region related modal
    this.alertModal = null;
    this.loadingModal = null;

    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
    };
    this.setLoadingModal = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    this.setShippingProfile = function (address) {
        this.shippingProfile = address;
        return this;
    }
    //#endregion related modal

    //#region setter
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.setToken = function (token) {
        this.token = token;
        return this;
    };
    this.clearModal = function () {
        this.tag = '';
        this.token = '';
        this.cbAction.clearCallback();
        this.cbClose.clearCallback();
    };
    ////#endregion setter

    //#region modal control
    this.show = function () {
        var config = {
            tag: this.tag,
            token: this.token,
            shippingProfile: this.shippingProfile
        };

        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion modal control
}
